export enum EUserCapability {
    RC_VOTE = 'rc-vote',
    RC_VOTE_VETO = 'rc-vote-veto',
    RC_EDIT_RISK_SECTION = 'rc-edit-risk-section',
    RC_EDIT_COMPLIANCE_SECTION = 'rc-edit-compliance-section',
    RC_EDIT_LEGAL_SECTION = 'rc-edit-legal-section',
    RC_EDIT_SECURITY_SECTION = 'rc-edit-security-section',
    RC_READ = 'rc-read',
    RC_AUDIT_VIEW = 'rc-audit-view',
    IC_VOTE = 'ic-vote',
    IC_VOTE_VETO = 'ic-vote-veto',
    IC_EDIT_PRICING_SECTION = 'ic-edit-pricing-section',
    IC_READ = 'ic-read',
    IC_AUDIT_VIEW = 'ic-audit-view',
    CLIENT_WRITE = 'client_write',
    CLIENT_READ = 'client_read',
    LEGAL_READ = 'legal-read',
    LEGAL_WRITE = 'legal-write',
    FORM_READ = 'form-read',
    FORM_WRITE = 'form-write',
    COMMENT = 'comment',
    IC_COMMENT = 'ic-comment',
    RC_COMMENT = 'rc-comment',
    ORGANISATION_WIDE = 'organisation-wide',
    GENERAL_AUDIT_VIEW = 'general-audit-view',
    SYSTEM_ADMINISTRATOR = 'system-administrator',
    WALLET_ADMINISTRATOR = 'wallet-administrator',
    INTERNAL_WALLET_ADMINISTRATOR = 'internal-wallet-administrator',
    COUNTERPARTY_ADMIN = 'counterparty-admin',
    CREATE_REQUEST = 'counterparty-create-request',
    APPROVE_REQUEST = 'counterparty-approve-request',
    ADD_WALLET = 'counterparty-add-wallet',
    APPROVE_WALLET = 'counterparty-approve-wallet',
    DELETE_WALLET = 'counterparty-delete-wallet',
    BD_NOTES_READ = 'bd-notes-read',
    BD_NOTES_WRITE = 'bd-notes-write',
    CREATE_API_KEY = 'counterparty-create-api-key',
    APPROVE_API_KEY = 'counterparty-approve-api-key',
    COUNTERPARTY_MANAGE_USERS = 'counterparty-manage-users',
    CREATE_TRANSFER = 'counterparty-create-transfer',
    APPROVE_TRANSFER = 'counterparty-approve-transfer',
    COMMITTEE_MEMBERS_READ = 'committee-members-read',
    COMMITTEE_MEMBERS_MANAGE = 'committee-members-manage',
}
